
	import Vue from "vue"
	import Component from "vue-class-component"
	import ContentHeader from "custom/ContentHeader.vue"
	import Page from "custom/Page.vue"
	import PageSlide from "@components/container/PageSlide.vue"
	import MyDetails from "custom/profile/MyDetails.vue"
	import MyCompany from "custom/profile/MyCompany.vue"
	import InsurerContact from "custom/profile/InsurerContact.vue"
	import Secured from "utils/security/Secured"
	import { session } from "api/index"
	import IcsIcon from "custom/ui/IcsIcon.vue"
	import PNavigationTabs from "@portal-components/ui/navigation/PNavigationTabs.vue"
	import PNavigationTabItem from "@portal-components/ui/navigation/PNavigationTabItem.vue"

	@Secured(session)
	@Component({
		components: {
			ContentHeader,
			PNavigationTabs,
			PNavigationTabItem,
			Page,
			PageSlide,
			MyDetails,
			MyCompany,
			InsurerContact,
			IcsIcon
		}
	})
	export default class Profile extends Vue {
		readonly baseTranslationKey = "profile"
	}
